// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bundle .custom-control-label{font-weight:400!important}.bundle i.famfamfam-silk{margin-right:0!important}.bundle .form-check-inline .form-check-input{margin-top:.25rem!important}.bundle #unit1,.bundle #unit2{font-size:93%}", ""]);
// Exports
module.exports = exports;
